var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.11388 14.0626C3.28855 14.2366 3.51988 14.3333 3.76655 14.3333C3.92455 14.3333 4.08055 14.292 4.21855 14.2153L8.01657 12.086L11.7779 14.2106C11.9926 14.3326 12.2419 14.362 12.4792 14.296C12.7166 14.2306 12.9139 14.0753 13.0352 13.8606C13.1132 13.722 13.1546 13.566 13.1546 13.408L13.1512 4.39063C13.1512 2.63396 12.0219 1.66663 9.97124 1.66663H6.02655C4.00455 1.66663 2.84522 2.61796 2.84522 4.27663V13.4106C2.84455 13.6566 2.93988 13.888 3.11388 14.0626Z",
    fill: "#009B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30937 8.94262C7.18137 8.94262 7.05337 8.89396 6.95604 8.79596L5.57668 7.41796C5.38134 7.22262 5.38134 6.90596 5.57668 6.71062C5.77201 6.51532 6.08868 6.51532 6.28401 6.71062L7.30937 7.73529L9.71337 5.33266C9.9087 5.13732 10.2254 5.13732 10.4207 5.33266C10.6154 5.52799 10.6154 5.84466 10.4207 6.03999L7.6627 8.79596C7.56537 8.89396 7.43737 8.94262 7.30937 8.94262Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkactive);
export default __webpack_public_path__ + "static/media/Bookmarkactive.cf3c3711.svg";
export { ForwardRef as ReactComponent };